<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回上一层" @click="backIndex"/>
      药品信息
    </div>
    <div class="search-input">
      <div class="search-btn">
        <button class="btn btn-left" @click="clear">清除内容</button>
        <button class="btn btn-right" @click.prevent="searchRecord">查询记录</button>
      </div>
    </div>

    <div class="search-result warpper" ref="wrapper">
      <ul class="result-content content">
        <li class="result-item" v-for="(item, index) in recordList" :key="index">
          <div class="item-name">药品名称：{{item.name}}</div>
          <div class="item-name">生产厂家：{{item.manufacturer}}</div>
          <div class="item-name">检测项目：{{item.testItem}}</div>
          <div class="item-name">安全风险等级：{{item.safetyRiskLevel}}</div>
          <div class="item-btn">
              <!--<el-button class="btn btn-left"
                      @click="alter">
                  修改
              </el-button>-->
            <el-button class="btn btn-right" @click="check(item.medicineId)">查看</el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      medicineName: null,  //药品名称
      recordList:[],
      keyword: null,
    };
  },
  created() {
    this.searchRecord();
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    this.$nextTick(() => {
      this._initBScroll()
    })
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回上一层
    backIndex() {
      this.$router.replace({name: 'medicineManagement'})
    },
    //查看
    check(medicineId) {
      this.$router.replace({name: 'medicineMessage', query: {medicineId: medicineId}})
    },
    //修改
    alter() {
      this.$router.replace({name: 'medicineMessageEdit', query: {isCreate: false}})
    },
    //新增
    create() {
      this.$router.replace({name: 'medicineMessageEdit', query: {isCreate: true}})
    },
    clear() {
      this.medicineName = null;
    },
    searchRecord() {
      this.page = 1;
      this.$http.httpGet('/app/laMedicineDetail/list', {
        page: 1,
        limit:10
      }).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          if (res.page.list.length == 0) {
            this.$message.info('查无记录')
          }
          this.recordList = res.page.list
          this.page++
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    _initBScroll() {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          //开启点击事件 默认为false
          click: true,
          scrollY: true,
          probeType: 3
        })
          // 一些监听
        this.scroll.on('scroll', (pos) => {
          if (pos.y - this.scroll.maxScrollY < -50) {
            this.isShowTips = true
          } else {
            this.isShowTips = false
          }
        })

        this.scroll.on('touchEnd', pos => {
          // 1.2.1监听下拉
          if (pos.y >= 50) {
            console.log('下拉刷新')
          }
          // 1.2.2监听上拉
          if (this.scroll.maxScrollY > pos.y + 50) {
            this.loading = true
            this.$http.httpGet('/app/laMedicineDetail/list', {
              page: this.page,
              limit: 10
            }).then(res => {
              this.loading = false
              if (res.code === 0 && res.msg === 'success') {
                if (res.page.list.length == 0) {
                  this.$message.info('没有更多数据了')
                  return
                }
                this.page++
                let arr = res.page.list
                this.recordList = this.recordList.concat(arr)
                this.$nextTick(() => {
                  this.scroll.refresh()
                  this.scroll.finishPullUp()
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else if (!this.$refs.wrapper) {
        return
      } else {
        this.scroll.refresh()
      }
    },
  },

}
</script>

<style scoped lang="scss">
//@import '@/assets/style/global.scss';
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;

  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .search-input {
    position: relative;
    margin: 10px 0 20px;
    overflow: hidden;
    .search-select {
      display: flex;
      justify-content: space-between;
      text-align: center;
      padding: 0 20px 10px;

      .el-select {
        width: 100%;
      }
    }
    .search-btn {
      margin-top: 0;
      padding: 0 20px;

      button {
        height: 3.2rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }
      .btn-left {
        float: left;
        width: 48%;
        background-color: rgb(207, 0, 0);
      }
      .btn-right {
        float: right;
        width: 48%;
        background-color: rgb(6, 175, 6);
      }
    }
  }

  .search-result {
    position: relative;
    padding: 0;
    height: calc(100vh - 50px - 70px);
    width: 100%;
    // height: 100%;
    overflow: hidden;

    .result-content {
      padding: 0 20px 10px;
      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 10px 10px 10px;
        border-radius: 0.5rem;
        margin-top: 1.6rem;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;

        .item-name,
        .item-inventory,
        .item-use{
          position: relative;
          margin-bottom: 5px;
          height: 2rem;
          text-align: left;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;
        }

        .item-btn {
          position: relative;
          margin-bottom: 25px;
          height: 2rem;
          line-height: 2rem;
          font-size: 1.4rem;
          color: #000;

          button {
            height: 3.2rem;
            font-weight: 700;
            display: inline-block;
            width: 98%;
            background-color: #3A9DF2;
          }
          .btn-left {
            float: left;
          }
          .btn-right {
            float: right;
          }
        }
      }
    }
  }
}


::v-deep .el-input__inner::-webkit-input-placeholder {
    color: #666;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.el-select-dropdown__item {
    font-size: 14px !important;
    line-height: 34px;
    padding: 0 20px;
}
</style>
